import { css } from '@repo/themes/styled-system/css';
import { version } from '../../../package.json';

const VersionFooter = () => (
  <span
    className={css({
      position: 'fixed',
      right: '16',
      bottom: '12',
      zIndex: 'header',
      fontSize: '[0.75rem]',
      color: 'gray.primary',
      pointerEvents: 'none',
      userSelect: 'none',
    })}
  >
    v{version}
  </span>
);

export default VersionFooter;
